import styles from './Dates.module.css';
import { classNames } from '@axo/shared/util/dom';
import { Classes } from '@blueprintjs/core';
import { formatDatetime } from '../../../utils/formatDate.ts';
import { UseQueryResult } from 'react-query';
import { loan_application } from '@axo/shared/data-access/types';

export const Dates = ({
  app,
}: {
  app: UseQueryResult<loan_application.LoanApplication>;
}) => {
  return (
    <div className={styles.dateContainer}>
      <div className={styles.date}>
        <span className={styles.label}>Created on:</span>
        <span
          className={classNames(
            Classes.TEXT_MUTED,
            app.isLoading && Classes.SKELETON
          )}
        >
          {formatDatetime(app.data?.CreatedAt || '')}
        </span>
      </div>
      <div className={styles.date}>
        <span className={styles.label}>Completed on:</span>
        <span
          className={classNames(
            Classes.TEXT_MUTED,
            app.isLoading && Classes.SKELETON
          )}
        >
          {app.data?.CompletedAt
            ? formatDatetime(app.data?.CompletedAt)
            : 'Not completed'}
        </span>
      </div>
      <div className={styles.date}>
        <span className={styles.label}>Last update on:</span>
        <span
          className={classNames(
            Classes.TEXT_MUTED,
            app.isLoading && Classes.SKELETON
          )}
        >
          {formatDatetime(app.data?.UpdatedAt || '')}
        </span>
      </div>
    </div>
  );
};
